import { render, staticRenderFns } from "./ResultStudentTwenty.vue?vue&type=template&id=182b0de4&scoped=true&"
import script from "./ResultStudentTwenty.vue?vue&type=script&lang=ts&"
export * from "./ResultStudentTwenty.vue?vue&type=script&lang=ts&"
import style0 from "./ResultStudentTwenty.vue?vue&type=style&index=0&id=182b0de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b0de4",
  null
  
)

export default component.exports